module.exports = __webpack_public_path__ + "static/media/park.d34a1695.svg";